var _defs, _g, _g2, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPenalty(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    "data-name": "Calque 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 150 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #47464b;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g878"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "g655"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M74.99,69.55c6.04,0,10.96,4.95,10.96,11.02s-4.91,11.03-10.96,11.03c-6.03,0-10.95-4.94-10.95-11.03s4.92-11.02,10.95-11.02ZM74.99,91.53c6.01,0,10.89-4.92,10.89-10.96s-4.88-10.95-10.89-10.95-10.88,4.91-10.88,10.95,4.89,10.96,10.88,10.96Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "path657"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M71.92,86.84c-1.37,1.05-2.23,1.51-2.84,1.67-1.22-1.02-2.46-2.31-3.28-3.56.17-1.13.42-2.22.76-3.28,1.27.31,2.54.62,3.82.91.51,1.42,1.03,2.84,1.54,4.26h0Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path658"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M78.53,90.31c-1.21-1.02-.9-.98-1.71-2.23.45-.59,2.74-2.51,3.27-3.47,1.2.14,2.15-.03,3.42.27.04,1.9-1.1,3.24-1.05,3.46h0c-.96.75-3.33,1.83-3.93,1.98h0Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path659"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M73.76,78.93c-.42-1.22-.57-3.26-.7-4.62.45-.56,3.12-1.53,4.3-1.87,1.48.88,2.6,2.37,3.39,3.47-.63,1.82-1.53,3.09-2.09,3.87-1.63-.27-3.26-.56-4.9-.85h0Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path660"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M84.22,76.78c.17-.88-.07-1.49-.25-2.15.05-.02.09,0,.13-.09,1.64,2.22,1.98,5.45,1.83,6.52-.12,0-.2-.02-.31-.04-.17-1.61-.79-3.29-1.4-4.23h0Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path661"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M64.77,76.66c.87-2.38,3.09-4.74,4.34-5.26.17.02.33,0,.47.02-.62.99-.49,1.86-.55,2.27-1.29.47-2.47,2.77-3.15,3.51-.38-.08-.55-.19-1.11-.54h0Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path662"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M75.81,69.59c.17.02,1.43.2,1.58.23,1.12.24,2.87.98,3.28,1.36-.99-.44-1.99-.72-2.41-.88-.26-.02-.39-.06-.92.14,0-.62-2.23-.74-2.59-.84.26-.05.37,0,1.06,0h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "path663",
    className: "cls-1",
    d: "M80.13,84.61c.08-1.34-.51-3.2-1.46-4.79"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M78.7,79.78c.99,1.67,1.55,3.52,1.47,4.82h-.08c.08-1.29-.49-3.12-1.46-4.77l.07-.05Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "path664",
    className: "cls-1",
    d: "M71.92,86.88c.55.4,2.89.98,4.96,1.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M71.95,86.86c.55.4,2.89.97,4.94,1.18v.08c-2.06-.21-4.42-.78-4.98-1.19l.05-.07Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "path665",
    className: "cls-1",
    d: "M73.77,78.92c-1.53,1.51-2.32,2.32-3.4,3.69"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M73.75,78.89l.06.06c-1.48,1.45-2.3,2.29-3.41,3.69l-.06-.05c1.11-1.4,1.94-2.25,3.42-3.7Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "path666",
    className: "cls-1",
    d: "M73.06,74.33c-1.57-.68-2.62-.82-4.01-.67"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M70.03,73.56c1.01,0,1.89.22,3.05.74l-.04.08c-1.49-.66-2.53-.84-3.99-.67v-.08c.34-.04.67-.06.98-.06Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "path667",
    className: "cls-1",
    d: "M77.39,72.51c.16-1.02.04-1.47-.02-2.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M77.41,70.46c.01.1.02.19.03.28.07.47.12.91-.01,1.77h-.08c.14-.86.08-1.29.02-1.76-.02-.08-.03-.18-.04-.28h.08Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "path668",
    className: "cls-1",
    d: "M80.72,75.92c2.65-.02,2.93.4,3.5.84"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M80.94,75.88c2.24,0,2.69.37,3.16.74.05.04.1.08.15.12l-.05.07c-.06-.03-.11-.07-.15-.11-.5-.4-.93-.74-3.33-.72v-.09h.22Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "path669",
    className: "cls-1",
    d: "M83.5,84.87c1.43-1.46,1.76-2.75,2.11-3.92"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M85.57,80.94l.08.02c-.03.07-.05.15-.08.23-.33,1.1-.71,2.34-2.04,3.71l-.06-.06c1.31-1.35,1.7-2.58,2.02-3.67.02-.08.05-.16.08-.23Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "path670",
    className: "cls-1",
    d: "M82.61,88.48c-.12-.07-.11-.06-.15-.12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M82.51,88.34h0s.03.05.11.1v.03s-.03.06-.03.06l-.02-.02c-.08-.04-.08-.05-.12-.11h0s.07-.06.07-.06Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "path671",
    className: "cls-1",
    d: "M71.51,90.95c-1.25-.84-2.1-1.96-2.42-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M69.13,88.48c.22.34,1.08,1.54,2.4,2.42l-.05.08c-1.34-.88-2.2-2.1-2.43-2.44l.08-.06Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "path672",
    className: "cls-1",
    d: "M65.9,77.24c0,.98.17,3.99.76,4.43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M65.94,77.24c0,.56.05,1.55.16,2.41.14,1.12.35,1.8.59,1.99l-.05.07c-.63-.48-.78-3.69-.79-4.47h.09Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "path673",
    className: "cls-1",
    d: "M64.56,84.03c.32.5.62.73,1.24.89"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M64.59,84c.32.5.63.73,1.23.87l-.02.08c-.62-.15-.94-.37-1.29-.91l.08-.04Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "path674",
    className: "cls-1",
    d: "M74.59,91.49c2.38-.28,3.35-.79,3.92-1.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M78.48,90.29l.05.08c-.6.38-1.6.88-3.93,1.17v-.08c2.31-.29,3.3-.77,3.88-1.17Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "path607"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M71.92,86.84c-1.37,1.05-2.23,1.51-2.84,1.67-1.22-1.02-2.46-2.31-3.28-3.56.17-1.13.42-2.22.76-3.28,1.27.31,2.54.62,3.82.91.51,1.42,1.03,2.84,1.54,4.26h0Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path608"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M78.53,90.31c-1.21-1.02-.9-.98-1.71-2.23.45-.59,2.74-2.51,3.27-3.47,1.2.14,2.15-.03,3.42.27.04,1.9-1.1,3.24-1.05,3.46h0c-.96.75-3.33,1.83-3.93,1.98h0Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path609"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M73.76,78.93c-.42-1.22-.57-3.26-.7-4.62.45-.56,3.12-1.53,4.3-1.87,1.48.88,2.6,2.37,3.39,3.47-.63,1.82-1.53,3.09-2.09,3.87-1.63-.27-3.26-.56-4.9-.85h0Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path610"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M84.22,76.78c.17-.88-.07-1.49-.25-2.15.05-.02.09,0,.13-.09,1.64,2.22,1.98,5.45,1.83,6.52-.12,0-.2-.02-.31-.04-.17-1.61-.79-3.29-1.4-4.23h0Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path611"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M64.77,76.66c.87-2.38,3.09-4.74,4.34-5.26.17.02.33,0,.47.02-.62.99-.49,1.86-.55,2.27-1.29.47-2.47,2.77-3.15,3.51-.38-.08-.55-.19-1.11-.54h0Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path612"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M75.81,69.59c.17.02,1.43.2,1.58.23,1.12.24,2.87.98,3.28,1.36-.99-.44-1.99-.72-2.41-.88-.26-.02-.39-.06-.92.14,0-.62-2.23-.74-2.59-.84.26-.05.37,0,1.06,0h0Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M78.7,79.78c.99,1.67,1.55,3.52,1.47,4.82h-.08c.08-1.29-.49-3.12-1.46-4.77l.07-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M71.95,86.86c.55.4,2.89.97,4.94,1.18v.08c-2.06-.21-4.42-.78-4.98-1.19l.05-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M73.75,78.89l.06.06c-1.48,1.45-2.3,2.29-3.41,3.69l-.06-.05c1.11-1.4,1.94-2.25,3.42-3.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M70.03,73.56c1.01,0,1.89.22,3.05.74l-.04.08c-1.49-.66-2.53-.84-3.99-.67v-.08c.34-.04.67-.06.98-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M77.41,70.46c.01.1.02.19.03.28.07.47.12.91-.01,1.77h-.08c.14-.86.08-1.29.02-1.76-.02-.08-.03-.18-.04-.28h.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M80.94,75.88c2.24,0,2.69.37,3.16.74.05.04.1.08.15.12l-.05.07c-.06-.03-.11-.07-.15-.11-.5-.4-.93-.74-3.33-.72v-.09h.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M85.57,80.94l.08.02c-.03.07-.05.15-.08.23-.33,1.1-.71,2.34-2.04,3.71l-.06-.06c1.31-1.35,1.7-2.58,2.02-3.67.02-.08.05-.16.08-.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M82.51,88.34h0s.03.05.11.1v.03s-.03.06-.03.06l-.02-.02c-.08-.04-.08-.05-.12-.11h0s.07-.06.07-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M69.13,88.48c.22.34,1.08,1.54,2.4,2.42l-.05.08c-1.34-.88-2.2-2.1-2.43-2.44l.08-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M65.94,77.24c0,.56.05,1.55.16,2.41.14,1.12.35,1.8.59,1.99l-.05.07c-.63-.48-.78-3.69-.79-4.47h.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M64.59,84c.32.5.63.73,1.23.87l-.02.08c-.62-.15-.94-.37-1.29-.91l.08-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M78.48,90.29l.05.08c-.6.38-1.6.88-3.93,1.17v-.08c2.31-.29,3.3-.77,3.88-1.17Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "path646"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M79.13,76.88c-.55.06-.72,1-.84,1.33-.35.94-.64,1.14-1.36.96-.69.03-2.06-.21-3.09-.41-.06-.43.07-1.99-.04-2.41-.1-.35-.44.07-.42-1.04.11.3.29,2.65.49,3.46.52.28,1.05.22,1.95.45.87.21,1.89.33,2.78.52.27-.2.39-.66.64-.84l.5-1.11s-.13-.94-.61-.9h0Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path717"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M70.34,82.65c-.74-.24-1.4-.31-2.23-.51-.39-.11-1.13-.32-1.49-.39.21.18.64.36.77.38.16.04,1.06.27,1.22.35.49.09.8.14,1.13.18.03,0,.46,0,.6,0h0Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path718"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M71.88,86.87c-.22-.87-.58-1.56-.9-2.48-.16-.44-.4-1.28-.56-1.7-.08.32.02.84.07.99.07.17.4,1.18.42,1.39.23.53.39.87.56,1.23.03.01.33.44.41.58h0Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path719"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M79.78,85.15c-.44.64-1.7,1.7-2.28,2.29-.21.18-.39.26-.59.6.21-.13,1.07-.87,1.12-.99.09-.13.87-.77.99-.9.24-.45.35-.18.49-.49,0-.04.54-.85.59-.98l-.33.48h0Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path720"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M83.49,84.91c-.5-.12-.74-.16-1.5-.16-.36-.04-1.54-.07-1.87-.12.19.13.59.22.71.22.14,0,.95.11,1.11.14.44.02.73.02,1.03,0,.02,0,.41-.07.53-.08h0Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path874"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M65.07,76.19c.77-2.02,2.75-4.05,3.84-4.5.16.03.3,0,.42.03-.56.85-.43,1.6-.48,1.94-1.14.4-2.2,2.36-2.81,2.99-.34-.07-.5-.15-.98-.47h0Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path876"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M84.22,76.78c.17-.88-.07-1.49-.25-2.15.05-.02.09,0,.13-.09,1.64,2.22,1.98,5.45,1.83,6.52-.12,0-.2-.02-.31-.04-.17-1.61-.79-3.29-1.4-4.23h0Z"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M28.72,43.14l-.32-37.55c0-.24.09-.47.26-.65s.4-.27.64-.27h90.94c.5,0,.9.4.91.9l.31,37.55-1.81.02-.31-36.65H30.22l.31,36.63-1.81.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M119.6,44.14l-7.27-7.37c-.22-.22-.31-.54-.24-.85l7.27-30.55,1.76.42-7.15,30.06,6.92,7.01-1.29,1.27Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 37.02,
    y: 35.23,
    width: 75.96,
    height: 1.81
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M49.69,36.31l-6.03-30.55c-.05-.27.02-.54.19-.75.17-.21.43-.33.7-.33h7.53c.45,0,.83.33.9.77l4.56,30.55-1.79.27-4.45-29.77h-5.65l5.81,29.46-1.78.35Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 39.86,
    y: 5.14,
    width: 1.81,
    height: 31.45,
    transform: "translate(-3.79 10.3) rotate(-13.77)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M100.08,36.31l-1.78-.35,5.81-29.46h-5.65l-4.46,29.77-1.79-.27,4.57-30.55c.07-.44.45-.77.9-.77h7.53c.27,0,.53.12.7.33.17.21.24.49.19.75l-6.03,30.55Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 93.29,
    y: 19.96,
    width: 31.45,
    height: 1.81,
    transform: "translate(62.8 121.78) rotate(-76.23)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 60.3,
    y: 5.51,
    width: 1.81,
    height: 30.7,
    transform: "translate(-1.78 6.21) rotate(-5.72)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 73.09,
    y: 19.96,
    width: 30.67,
    height: 1.81,
    transform: "translate(59.69 107.05) rotate(-84.84)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 67.07,
    y: 5.57,
    width: 1.81,
    height: 30.59,
    transform: "translate(-1.03 3.72) rotate(-3.11)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 66.42,
    y: 19.85,
    width: 30.58,
    height: 1.81,
    transform: "translate(57.02 101.37) rotate(-87.22)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M74.89,37.04h0c-.5,0-.9-.41-.9-.91h0s.11-30.55.11-30.55c0-.5.41-.9.91-.9h0c.5,0,.9.41.9.91h0s-.11,30.55-.11,30.55c0,.5-.41.9-.91.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M119.37,21.09l-1.69-6.78H31.28v-1.81h87.1c.42,0,.78.28.88.69l1.86,7.47-1.76.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M119.43,28.85l-3.39-7.08H33.17v-1.81h83.45c.35,0,.67.2.82.52l3.63,7.59-1.64.78Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 35.09,
    y: 27.55,
    width: 79.71,
    height: 1.81
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "29.93 44.16 28.68 42.85 36.01 35.85 28.43 5.81 30.19 5.37 38.03 36.43 29.93 44.16"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 30.59,
    y: 5.45,
    width: 1.81,
    height: 34.02,
    transform: "translate(-2.63 4.24) rotate(-7.39)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M120.07,44.16l-7.72-7.37c-.24-.23-.33-.56-.25-.88l7.72-30.55c.12-.47.58-.76,1.05-.67.47.09.79.53.73,1.01l-4.32,33.28,4.04,3.86-1.25,1.31ZM113.98,35.85l1.66,1.59,2.18-16.79-3.84,15.2Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 27.66,
    y: 31.39,
    width: 9.41,
    height: 1.81,
    transform: "translate(-12.7 40.04) rotate(-54.68)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 26.92,
    y: 23.7,
    width: 8.6,
    height: 1.81,
    transform: "translate(-4.72 41.61) rotate(-63.56)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 26.36,
    y: 16.06,
    width: 7.82,
    height: 1.81,
    transform: "translate(6.4 42.16) rotate(-75.82)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 116.61,
    y: 27.99,
    width: 1.81,
    height: 9.05,
    transform: "translate(4.09 77.27) rotate(-37)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M87.52,93.1c0,.78-5.61,1.42-12.53,1.42-6.91,0-12.52-.63-12.52-1.42s5.6-1.41,12.52-1.41,12.53.63,12.53,1.41Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPenalty);
export default __webpack_public_path__ + "static/media/penalty.b7a50e1cdca838fb3452e0eb53059629.svg";
export { ForwardRef as ReactComponent };